import { authFetch } from 'auth/utils';
import {
  CurrentAppliedConfigurationDetails,
  PossibleConfigurationToRevert,
} from './rSimConfigurationApi.types';
import { envVariables } from 'src/common/utils/envVariables';

export const fetchRSimPossibleOTAConfigurationsToRevert = async (
  euicc: string,
  signal?: AbortSignal,
) => {
  const possibleConfigurationsToRevertResponse = await authFetch(
    `${envVariables.VITE_RSIM_INVENTORY_INGESTION_OTA_API}/configurations/configurations-possible-to-revert?Euicc=${euicc}`,
    { signal },
  );

  const configurations: PossibleConfigurationToRevert[] =
    await possibleConfigurationsToRevertResponse.json();
  return configurations;
};

export const revertConfigurationVersion = async (configuration: PossibleConfigurationToRevert) => {
  return await authFetch(`${envVariables.VITE_RSIM_INVENTORY_INGESTION_OTA_API}/versions/revert`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      euicc: configuration.euicc,
      rsimOtaProfileIdentifier: configuration.rsimOtaProfileIdentifier,
      rsimOtaProfileVersion: configuration.rsimOtaProfileVersion,
    }),
  });
};

export const fetchRSimCurrentAppliedConfigurationDetails = async (
  euicc: string,
  signal?: AbortSignal,
) => {
  const currentAppliedConfigurationDetails = await authFetch(
    `${envVariables.VITE_RSIM_INVENTORY_INGESTION_OTA_API}/configurations/current-applied-configuration-details?Euicc=${euicc}`,
    { signal },
  );

  const appliedConfigurationDetails: CurrentAppliedConfigurationDetails =
    await currentAppliedConfigurationDetails.json();
  return appliedConfigurationDetails;
};
